/************************************ CART PAGE AJAX  ******************************************/
$(document).ready(function(){   

  $(".cart-table-item-remove").click(function(event){
    console.log("CLICK");
    event.preventDefault();
    var href = $(this).children("a").attr('data-href');
    var main_quantity =  $(this).attr("data-count");

    var stud_text = $(this).prev(".properties").children(".properties_stud").length;
    var embriodery = $(this).prev(".properties").children(".properties_embriodery").length;
    console.log(stud_text+stud_text);
    if(stud_text != 0 && embriodery == 0){
      console.log("Stud only fill");
      var stud = $(".StudsSect").attr("data-number");
      stud = (stud-main_quantity);
      stud = parseInt(stud);

      jQuery.post('/cart/update.js', {updates: {13632859439152: stud}});   
      setTimeout(function(){ 
        window.location.href = href;

      }, 1000);

    }

    else if(embriodery != 0 && stud_text == 0){

      console.log("Emb not stud blank");
      var emb = $(".EmbSect").attr("data-number");
      emb = (emb-main_quantity);
      emb = parseInt(emb);

      jQuery.post('/cart/update.js', {updates: {13632862486576: emb}});   
      setTimeout(function(){ 
        window.location.href = href;

      }, 1000);

    }
    else if(embriodery != 0 && stud_text != 0){
      console.log("Both fill");

      var emb = $(".EmbSect").attr("data-number");
      var stud = $(".StudsSect").attr("data-number");
      emb = (emb-main_quantity);
      stud = (stud-main_quantity);
      emb = parseInt(emb);
      stud = parseInt(stud);

      jQuery.post('/cart/update.js', {updates: {13632859439152: stud, 13632862486576: emb}});   
      setTimeout(function(){ 
        window.location.href = href;

      }, 3000);
    }
    else{
      console.log("Both blank");
      window.location.href = href;
    }
  })
})